import type { Page } from '../../types';

const talentCareerQ4: Page[] = [
  {
    pageType: 'question',
    title: 'Reporting Manager End-of-Year Assessment of Talent',
    name: 'talent-career-q4',
    description:
      'Alongside Performance, individuals and line managers should regularly discuss talent and development, and agree a 9 Box Grid position.<br><br>',
    questions: [
      {
        questionType: 'select',
        title: 'How long have you been at your current substantive grade',
        name: 'talent-career-how-long-current-grade-q4',
        hintOption: 'Select an option',
        options: [
          '0 - 1 Year',
          '1 - 2 Years',
          '2 - 3 Years',
          '3 - 5 Years',
          '5 - 10 Years',
          '10+ Years',
        ],
        rules: {
          required: true,
        },
      },
      {
        questionType: 'textarea',
        title:
          'Please list any development activity undertaken over the past 12 months to support your current role or future roles, including on-the-job learning, procured training, and schemes/programmes which you have participated in.',
        name: 'talent-career-development-activity-q4',
        rules: {
          required: true,
        },
      },
      {
        questionType: 'textarea',
        title: 'Please copy your most recent talent bio here.',
        name: 'talent-career-talent-bio-q4',
        rules: {
          required: true,
        },
      },
      {
        questionType: 'radio',
        title: 'Is this talent bio up-to-date?',
        name: 'person-details-talent-bio-uptodate-q4',
        hintOption: 'Select an option',
        options: ['Yes', 'No'],
        rules: {
          required: true,
        },
      },
      {
        questionType: 'textarea',
        title:
          'If not already listed in your bio, please list any historic formal development schemes/programmes you have participated in at your current grade, and the year of completion (HPDS / DLP / Forward Institute programmes etc).',
        name: 'talent-career-additional-development-schemes-q4',
        rules: {
          required: false,
        },
      },
      {
        questionType: 'radio',
        title: 'Do you have the aspiration of reaching at least the next SCS grade in your career?',
        name: 'person-details-aspiration-q4',
        hintOption: 'Select an option',
        options: ['Yes', 'No'],
        rules: {
          required: true,
        },
      },
      {
        questionType: 'radio',
        title: 'Do you expect your next role to be at your current substantive grade?',
        name: 'person-details-next-role-same-grade-q4',
        hintOption: 'Select an option',
        options: [
          {
            option: 'Yes',
            questions: [
              {
                questionType: 'textarea',
                title:
                  'Please provide details of which roles you are considering and the likely timeframe',
                name: 'person-details-next-role-same-grade-details-q4',
                rules: { required: true },
              },
            ],
          },
          {
            option: 'No',
            questions: [
              {
                questionType: 'textarea',
                title:
                  'Please provide details of which roles you are considering and the likely timeframe',
                name: 'person-details-next-role-same-grade-details-q4',
                rules: { required: true },
              },
            ],
          },
        ],
        rules: {
          required: true,
        },
      },
      {
        questionType: 'textarea',
        title: 'Are there any further comments which you would like to make?',
        name: 'talent-career-further-comments-q4',
        rules: {
          required: false,
        },
      },
    ],
  },
];

export default talentCareerQ4;
